export const TransportationCardQuestions = [
    {
        eventQuestionId: 0,
        eventId: 0,
        isMandatoryQuestion: true,
        eventQuestion: "Will you be taking the shuttle bus service from pick-up point to the event venue?",
        eventQuestionTypeId: 2,
        isFeedbackQuestion: false,
        answers: [
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "Yes",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "No",
                "isOther": false
            },
        ],
        isOther: false,
    },
    {
        eventQuestionId: 0,
        eventId: 0,
        isMandatoryQuestion: true,
        eventQuestion: "Will you be taking the shuttle bus service from the event venue to the pick-up point?",
        eventQuestionTypeId: 2,
        isFeedbackQuestion: false,
        answers: [
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "Yes",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "No",
                "isOther": false
            },
        ],
        isOther: false,
    },
]